<template>
  <span class="ai-visibility-status-legend-item">
    <status-dot :status="status" :size="14" />
    <span>{{ label }}</span>
  </span>
</template>

<script>
import StatusDot from './StatusDot.vue'

export default {
  name: 'StatusLegendItem',
  components: {
    StatusDot,
  },
  props: {
    status: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-status-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--v-mainColor3-base);
  white-space: nowrap;

  span {
    font-size: 14px;
  }
}
</style>
